import { useAoApi } from "@lending/lib/api";

function useAcceptConsumerApplicationDisclosuresMutation() {
  const $aoApi = useAoApi();

  return $aoApi.useMutation(
    "post",
    "/v2/account_opening/consumer/applications/{uuid}/accept_disclosures/"
  );
}

export { useAcceptConsumerApplicationDisclosuresMutation };
